// When the design system is used with shadow dom as parent, the event target is always
// the root of the shadow dom so we need to make sure that we read the correct target
// and make that available.

// In non-shadow dom environments this is a long-about way of doing it but its not wrong.
const getEventTarget = (e) => {
  if (e.composedPath && typeof e.composedPath === 'function') {
    const paths = e.composedPath();
    return paths && paths.length > 0 ? paths[0] : e.target;
  }

  return e.target;
};

export {
  getEventTarget,
};
